import {Component, Input, OnInit, ViewChild} from '@angular/core';
// import Swiper core and required modules
import {SwiperComponent} from 'swiper/angular';
import SwiperCore, {SwiperOptions, EffectFlip, Virtual} from 'swiper';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AppService} from '../../../../services/app.service';
// install Swiper modules
SwiperCore.use([EffectFlip, Virtual]);
import * as $ from 'jquery';
import UIkit from 'uikit';

@Component({
  selector: 'app-live-matches-card',
  templateUrl: './live-matches-card.component.html',
  styleUrls: ['./live-matches-card.component.css', '../live-matches.component.css']
})
export class LiveMatchesCardComponent implements OnInit {

  public pollData: any;
  public iplID: any;
  public question: any;
  public matchType;
  backflip = true;
  enable = true;
  public agreePercent = 0;
  public disAgreePercent = 0;
  public notAllowedToSubmit = false;
  public errorMessage = '';


  @Input()
  get data(): string {
    return this.question;
  }

  set data(data: any) {
    this.question = data;
  }

  @Input()
  get IPL_ID(): string {
    return this.iplID;
  }

  set IPL_ID(data: any) {
    this.iplID = data;
  }

  @Input()
  get pollObject(): string {
    return this.pollData;
  }

  set pollObject(data: any) {
    this.pollData = data;
  }

  @Input()
  get MatchType(): string {
    return this.matchType;
  }

  set MatchType(data: any) {
    this.matchType = data;
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private loadingBar: LoadingBarService,
    private router: Router,
    private activatedRoue: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    protected $gaService: GoogleAnalyticsService,
    private deviceService: DeviceDetectorService,
    private appService: AppService
  ) {
  }

  ngOnInit(): void {
    console.log('matchType', this.matchType);
  }

  //Swiper Code
  @ViewChild('swiper', {static: false}) swiper?: SwiperComponent;

  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    scrollbar: {draggable: false},
  };

  slideNext() {
    this.swiper.swiperRef.slideNext(300);
  }

  slidePrev() {
    this.swiper.swiperRef.slidePrev(300);
  }

  submitOpinion(userOpinion = 'Agree', question, poll): void {
    if (this.appService.getAccessToken()) {
      this.loadingBar.start();
      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      };

      this.http.post<any>(environment.domain + '/api/save/users/choice', {
        ipl_id: this.iplID,
        question_id: this.question.id,
        merchant_id: this.pollData.merchant.id,
        poll_id: this.pollData.id,
        opinion: userOpinion,
        status: 'ABC'
      }, httpOptions).subscribe(
        data => {
          console.log(data.type);
          this.loadingBar.stop();
          if (data.type === 'success') {
            this.backflip = true;
            this.agreePercent = data.data.agree;
            this.disAgreePercent = data.data.disagree;
            this.swiper.swiperRef.slideNext(300);
          } else {
            this.notAllowedToSubmit = true;
            this.errorMessage = data.message;
          }
        },
        error => {
          this.loadingBar.stop();
          console.error('There was an error!', error);
        });
    } else {
      this.notAllowedToSubmit = true;
      this.errorMessage = 'You must be logged in to play.';
      UIkit.modal('#modal-center').show();
    }
  }
}
